// src/com/arrival_to_store/ArrivalToStoreGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * ARRIVAL_TO_STORE Apollo Graphql
 * VIEW
 * Project: NewTOP for cloud
 * 2024-12-23 10:28:29 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const ARRIVAL_TO_STORE_LIST_PART = gql`
fragment ArrivalToStoreListPart on ArrivalToStore {
    planId
    dcReturnKpp
    dcReturnAju
    dcReturnRollcage
    dcReturnSpt
    dcReturnNjc800
    dcReturnDanpra
    dcReturnEtc
    dcReturnNote
    dcReturnSpt533
    dcReturnFull
    dcReturnHalf
    dcReturnSealNo
    dcReturnSealNo2
    dcReturnSealNo3
    dcReturnWooden
    dcReturnOctagon
    dcReturnStackKpp
    dcReturnStackAju
    returnDriverCheckYn
    returnDriverCheckDate
    returnStoreCheckYn
    returnStoreCheckDate
    returnDcCheckYn
    returnDcCheckDate
    returnDcCheckUser
    collectorDate
    collectorSignature
    dcCoverStores
    dcCoverStore1
    dcCoverItem1
    dcCoverStore2
    dcCoverItem2
    dcCoverStore3
    dcCoverItem3
    dcNoReturnCode
    dcNoReturnNote
    dcNoReturnDate
    dcNoReturnUser
    regUser
    regUserName
    insertTime
    inputBool
    returnDcCheckUserName
    vehPlates
    driverName
    driverMobile
    dcCd
    arriveId
    storeId
    comId
    planDate
    planTime
    hocha
    vehTypeId
    vehTypeName
    prosDptrTime
    prosArrTime
    arrReqTime
    inputArrTime
    traceStatus
    reqStateFlag
    dcTypeCd
    dcTypeName
    dcName
    comName
    storeName
    vehInfoSeq
    gpsTime
    transPosYn
    aPalKpp
    aPalAju
}
`;

/* const ARRIVAL_TO_STORE_NO_LIST_PART = gql`
fragment ArrivalToStoreNoListPart on ArrivalToStore {
}
`; */

// 점포관리 화면의 목록.
export const LIST_ARRIVAL_TO_STORE = gql`
${ARRIVAL_TO_STORE_LIST_PART}
query ListArrivalToStore($dateFrom: String!, $dateTill: String!) {
    arrivalToStoreList(dateFrom: $dateFrom, dateTill: $dateTill) {
        ...ArrivalToStoreListPart
    }
}
`;


export const GET_ARRIVAL_TO_STORE = gql`
${ARRIVAL_TO_STORE_LIST_PART}
query GetArrivalToStore($planId: String!) {
    arrivalToStoreItem(planId: $planId) {
        ...ArrivalToStoreListPart
    }
}
`;
